"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, useAccordionItemState, useMultiStyleConfig, } from "@chakra-ui/react";
import SvgSpriteConsumer from "../../atoms/SvgSprite/SvgSpriteConsumer";
const AccordionChevron = () => {
    const { isOpen } = useAccordionItemState();
    const styles = useMultiStyleConfig("Accordion", { isOpen });
    return (_jsx(Box, Object.assign({ sx: styles.icon }, { children: _jsx(SvgSpriteConsumer, { svgId: "chevronDown24", size: 24 }) })));
};
AccordionChevron.displayName = "AccordionChevron";
export default AccordionChevron;
//# sourceMappingURL=AccordionChevron.js.map